import AnnouncementIcon from '@material-ui/icons/Announcement';
import AnnouncementList from './AnnouncementList';
import AnnouncementCreate from './AnnouncementCreate';

export default {
    list: AnnouncementList,
    create: AnnouncementCreate,
    icon: AnnouncementIcon,
};
